import { PATH_BACKEND, PATH_BACKEND_PART } from 'configs/routes/pathsBackend';
import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import {
  ServerActionDynamicMetadataResponseDTO,
  ServerActionRequestDTO,
  ServerActionResponseDTO,
  StartActionRequestDTO,
} from 'typings/dto/serverAction';
import IServerActionActionsService from './IServerActionActionsService';
import NavigateBackendUtils from 'utils/NavigateBackend';
import ServerActionUtils from 'utils/models/ServerActionUtils';
import { batch as reduxBatch } from 'react-redux';

export default class ServerActionActionsServiceImpl
  extends ModelActionsService<ServerAction, ServerActionRequestDTO, ServerActionResponseDTO>
  implements IServerActionActionsService
{
  // Вся статическая информация касательно экшенов, полученная ранее, хранится здесь для оптимизации количества запросов
  private cache: { action: Record<string, ServerAction> } = {
    action: {},
  };

  public setToCache(value: ServerAction, key: string, valueType: 'action') {
    this.cache[valueType][key] = value;
  }

  public getCache(key: string, valueType: 'action'): ServerAction {
    return this.cache[valueType][key];
  }

  public getActionMetadata = async (dto: ServerActionRequestDTO) => {
    this.storageDispatch(this.modelStorageActions.startLoading());
    const serverAction = await this.requestActionMetadata(dto);
    reduxBatch(() => {
      this.setOne(serverAction);
      this.storageDispatch(this.modelStorageActions.stopLoading());
    });
  };

  public requestActionMetadata = async (dto: ServerActionRequestDTO) => {
    const [staticMetadata, dynamicMetadata] = await Promise.all([this.getStaticMetadata(dto.formName), this.getDynamicMetadata(dto)]);
    return ServerActionUtils.mergeMetadata(staticMetadata, dynamicMetadata);
  };

  public getStaticMetadata = async (formId: string) => {
    const path = PATH_BACKEND.action.vx + '/' + PATH_BACKEND_PART.action.meta;
    const cachedAction = this.getCache(formId, 'action');
    if (cachedAction) {
      return cachedAction;
    }
    const actionData = await this.modelApiService.getById(path, formId, this.modelMapper);
    this.setToCache(actionData, formId, 'action');
    return actionData;
  };

  public getDynamicMetadata = async ({ orderId, formName }: ServerActionRequestDTO) => {
    let path = PATH_BACKEND.action.vx + '/' + formName;
    path = NavigateBackendUtils.addParamsToExistedUrl(path, { orderId });
    return this.entityApiService.getWithCredentials<ServerActionDynamicMetadataResponseDTO>(path);
  };

  /** @throws `BackendResponseError` */
  public applyForm = async (dto: StartActionRequestDTO) => {
    const path = PATH_BACKEND.action.vx;
    return this.entityApiService.postWithCredentials<void>(path, dto, false);
  };
}
